import React, { useState } from "react";

function Footer() {

  const [isOpen, setIsOpen] = useState(false);

  return (
     <footer class="py-4 text-center text-muted border-top ">
       RCML All rights reserved.&copy; 2026 . 
    </footer>

  );
}

export default Footer;